<div class="documentary-space__documents-page">
    <section class="cand-modal__content">
        <div class="documentary-space__back" (click)="backToSelection()">
            <div class="documentary-space__back-button"></div>
            <div class="documentary-space__back-label">
                {{ 'documents.mobile.backDocumentHome' | i18n }}
            </div>
        </div>
        <h2 class="page-subtitle page-subtitle--primary page-subtitle--uppercase page-subtitle--centered">
            Dossier n°{{ currentContextDossier.emprunteur.idSousDossier.toString() }}-
            {{ 'global.insurance.productCode.' + codeProduit | i18n }}
        </h2>
        <div>
            <ul class="pills pills--with-content pills-link">
                <li *ngFor="let docType of docTypes" class="pill">
                    <div class="pill__header pill__header--link-content" (click)="selectPill(docType)">
                        <span class="pill__header__title">
                            {{ 'documents.types.' + docType | i18n }}
                        </span>
                    </div>

                    <div class="pill__content ng-hide" *ngIf="docType === selectedPill">
                        <ul class="pills">
                            <li class="documents-list__item" *ngFor="let item of filterDoc">
                                <div class="documents-list__item-button">
                                    <a (click)="downloadFile(item)" class="button button--primary" *ngIf="item.idGed" data-tag-commander="" [appTagCommander]="'tagCo.documents.document.' + item.typologie + '.download'">
                                        <span data-ng-transclude="">
                                            <em class="icon icon--download-line"></em>
                                        </span>
                                    </a>
                                </div>
                                <div class="documents-list__item-header">
                                    <span class="documents-list__item-title">
                                        {{ item.libelleNatureDocument }}
                                    </span>
                                    <span class="documents-list__item-info"> {{ 'documents.provided' | i18n }}&nbsp;{{ item.dateDepot | date: 'dd/MM/yyyy' }} </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </section>
</div>
